/* @ngInject */
const railwayRequest = (
  $q,
  railwayResource,
  utils,
  valueHandler,
  labels,
  errorHandler
) => {
  const self = {}

  self.getBySearch = async (data) => {
    return $q((resolve, reject) => {
      const functionName = '$railway.getBySearch'
      railwayResource.post({ action: 'search', }, { search: data }, (res) => {
        if (res && res.success && valueHandler.isArray(res.data)) {
          const response = {
            railways: res.data,
            message: labels.railway.log.search.success(res.data.length),
            color: res.data.length === 0 ? 'orange' : 'green',
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, data)
          reject(labels.railway.log.search.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.getAll = async () => {
    return self.getBySearch()
  }

  self.getById = async (_id) => {
    return $q(async (resolve, reject) => {
      try {
        const response = await self.getBySearch({ id: _id, })
        const railways = response.railways
        if (railways.length === 1) {
          resolve(railways[0])
        } else {
          reject(labels.railway.log.search.noResult)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  self.getByNumber = async (_number) => {
    return $q(async (resolve, reject) => {
      try {
        const response = await self.getBySearch({ number: _number, })
        const railways = response.railways
        if (railways.length === 1) {
          resolve(railways[0])
        } else {
          reject(labels.railway.log.search.noResult)
        }
      } catch (error) {
        reject(error)
      }
    })
  }

  self.getByArea = async (_areaId) => {
    return $q(async (resolve, reject) => {
      if (!valueHandler.isId(_areaId)) {
        reject(labels.railways.fields.areaId.messages.invalid)
      }

      try {
        const response = await self.getBySearch({ areaId: _areaId, })
        const railways = response.railways
        resolve(railways)
      } catch (error) {
        reject(error)
      }
    })
  }

  self.save = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$railway.save'

      railwayResource.save({}, _data, (res) => {
        if (res && res.success && valueHandler.isId(res.data.id)) {
          const response = {
            id: res.data.id,
            message: labels.railway.log.save.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 2) {
            reject(labels.railway.log.save.alreadyExists)
          } else {
            errorHandler.message(res, functionName, _data)
            reject(labels.railway.log.save.failure)
          }
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.update = (_data) => {
    return $q((resolve, reject) => {
      const functionName = '$railway.update'
      railwayResource.update({ action: _data.id }, _data, (res) => {
        if (res && res.success) {
          const response = {
            railway: res.data,
            message: labels.railway.log.update.success,
          }
          resolve(response)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          errorHandler.message(res, functionName, _data)
          reject(labels.railway.log.update.failure)
        }
      }, (error) => {
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  self.delete = async (_id) => {
    return $q((resolve, reject) => {
      const functionName = '$railway.delete'
      railwayResource.delete({ action: _id, }, (res) => {
        if (res && res.success) {
          resolve(labels.railway.log.delete.success)
        } else if (valueHandler.isString(res)) {
          reject(res)
        } else {
          if (res.code === 23000) {
            reject(labels.railway.log.delete.wagonOnRailway)
          } else {
            errorHandler.message(res, functionName, _id)
            reject(labels.railway.log.delete.failure)
          }
        }
      }, (error) => {
        if (error.data.message) {
          reject(error.data.message)
        }
        errorHandler.status(error, functionName)
        reject(labels.log.failure)
      })
    })
  }

  return self
}

export default railwayRequest



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/services/request.service.js